import React, {useEffect,useState,useContext,useRef,forwardRef,useImperativeHandle} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import FileImage from './FileImage';
import { PiImageThin } from 'react-icons/pi';
import { formatDate, X_PADDING } from '../constants';

const NewsForm = forwardRef(({newsItem}, ref) => {
    const [file, setFile] = useState(newsItem?.file ?? null);
    const [name, setName] = useState(newsItem?.name ?? '');
    const [description, setDescription] = useState(newsItem?.description ?? '');
    const [tag, setTag] = useState(newsItem?.tag ?? '');
    const [date, setDate] = useState(newsItem?.date ? new Date(newsItem.date) : new Date());

    useImperativeHandle(ref, () => ({
        getData() {
            return {
                ref: newsItem?.ref,
                file,
                name,
                tag,
                date,
                description
            };
        }
    }));
    
    const handleFileChosen = (imageFile) => {
        if (!imageFile) return;

        const extension = imageFile.name.split(".").pop().toLowerCase();

        // Optional validation
        const allowedExtensions = ["jpg", "jpeg", "png", "gif", "webp"];

        if (!allowedExtensions.includes(extension)) {
            alert("Please select a valid image.");
            return;
        }

        setFile(imageFile);
    };

    return (
        <div className="relative flex flex-col space-y-4 max-w-full w-[512px] h-full shrink-0 overflow-hidden">
            <div
                id="drop_zone"
                onDrop={(e) => {
                    e.preventDefault();
                    handleFileChosen(e.dataTransfer.files[0]);
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                }}
                className="flex flex-col w-full h-full items-center justify-center text-[rgb(93,93,93)] bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg p-4"
            >
                {file? (
                    <>
                        <FileImage file={file}
                            alt="Preview"
                            className="max-h-[400px] max-w-full object-contain rounded-lg mb-4"
                        />
                        <p className="mb-2">{}</p>

                        <label
                            htmlFor="img"
                            className="cursor-pointer text-theme hover:underline"
                        >
                            Choose another image
                        </label>
                    </>
                ) : (
                    <>
                        <PiImageThin size={64} className="text-theme" />

                        <p className="text-xl">
                            Drag and drop an image here
                        </p>

                        <p className="text-lg">-or-</p>

                        <label
                            htmlFor="img"
                            className="flex shrink-0 w-auto h-10 items-center justify-center text-xl hover:text-theme cursor-pointer"
                        >
                            Browse
                        </label>
                    </>
                )}

                <input
                    type="file"
                    id="img"
                    name="userImage"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => {
                        handleFileChosen(e.target.files?.[0]);
                    }}
                />
            </div>
            <textarea
                value={name?name:''}
                placeholder='Heading'
                onChange={e => setName(e.target.value)}
                className='flex w-full h-10 shrink-0 p-2 focus:outline-none text-sm font-light whitespace-nowrap bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg'
            />
            <input
                type="text"
                value={tag?tag:''}
                placeholder='Tag'
                onChange={e => setTag(e.target.value)}
                className='flex w-full h-10 shrink-0 p-2 focus:outline-none text-sm font-light whitespace-nowrap bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg'
            />
            <input
                type="date"
                value={date ? formatDate(date):formatDate(new Date())}
                placeholder='Date'
                onChange={e => setDate(new Date(e.target.value))}
                className='flex w-full h-10 shrink-0 p-2 focus:outline-none text-sm font-light whitespace-nowrap bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg'
            />
            <textarea
                value={description?description:''}
                placeholder="Body"
                onChange={e => setDescription(e.target.value)}
                className='flex w-full shrink-0 p-2 focus:outline-none text-sm font-light bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg'
            />
        </div>
    )
});

export default NewsForm